exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dob-picker[data-v-3337fc79] .dp-month-display{display:none}", ""]);

// exports
